// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gChl","content":"styles_content__1aG73","row":"styles_row__Vs3oa","footer":"styles_footer__19dCS","phraseLength":"styles_phraseLength__1F-SV"};